const grModel = {
  filterType: '',
  chartName: ['ch-share-of-shelf-overview', 'ch-share-of-shelf-facings'],
  grType: 'gr_product',
  valueKey: 'brand'
};

export default grModel;
